import { selectedActiveOrderIdAtom } from '@/features/shop/state/SelectedActiveOrder/atoms'
import { useAtomValue, useSetAtom } from 'jotai'
import { useQueryOrder } from '@/features/shop/services/Orders/queries'

export const useActiveOrder = () => {
  const currentActiveOrderId = useAtomValue(selectedActiveOrderIdAtom)
  return useQueryOrder(currentActiveOrderId ?? 0).data
}

export const useSetActiveOrder = () => {
  const setOrderId = useSetAtom(selectedActiveOrderIdAtom)

  return (orderId: number | null) => {
    setOrderId(orderId)
  }
}

export const useCurrentActiveOrderId = () => {
  return useAtomValue(selectedActiveOrderIdAtom)
}

export const useIsOrder = () => {
  const currentActiveOrderId = useCurrentActiveOrderId()
  return Boolean(currentActiveOrderId)
}

export const useClearActiveOrder = () => {
  const setOrderId = useSetAtom(selectedActiveOrderIdAtom)

  return () => {
    setOrderId(null)
  }
}
